// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Context = require("../../../../provider/Context.bs.js");
var UseOnBlur = require("../../../../hook/UseOnBlur.bs.js");
var UseToggle = require("../../../../hook/UseToggle.bs.js");
var Atom_Column = require("../../../atom/Atom_Column.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Header = require("../../../../type/Type_Header.bs.js");
var UseClickOutside = require("../../../../hook/UseClickOutside.bs.js");
var Particle_Screen_Ds = require("../../../particle/Particle_Screen_Ds.bs.js");
var UseTrackingAmplitude = require("../../../../hook/UseTrackingAmplitude.bs.js");
var Molecule_BurgerMenuIcon = require("../../../molecule/Molecule_BurgerMenuIcon.bs.js");
var Organism_MenuNavigation = require("./Organism_MenuNavigation.bs.js");
var Molecule_BurgerMenuIcon_Ds = require("../../../molecule/Molecule_BurgerMenuIcon_Ds.bs.js");

function Organism_BurgerMenu(Props) {
  var menuNavigation = Props.menuNavigation;
  var category = Props.category;
  var display = Props.display;
  var match = Context.I18n.getState(undefined);
  var trackAmplitude = UseTrackingAmplitude.useUserAction("menu_button");
  var match$1 = UseToggle.make(undefined, undefined, undefined, undefined);
  var close = match$1.close;
  var state = match$1.state;
  var toggle = match$1.toggle;
  var ref = React.useRef(null);
  var handleToggle = function ($$event) {
    Curry._1(toggle, $$event);
    Curry._1(trackAmplitude, undefined);
  };
  UseClickOutside.make(ref, close);
  UseOnBlur.make(ref, close);
  var rules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.position(CssJs.unset)]);
  var tmp = {
    children: null,
    height: Type_Header.Constants.heightStyle,
    justifyContent: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center"),
    kind: {
      TAG: /* Nav */10,
      _0: match.labels.navbar.mainNavigation
    },
    ref_: ref,
    rules: rules
  };
  if (display !== undefined) {
    tmp.display = Caml_option.valFromOption(display);
  }
  var tmp$1 = {
    menuNavigation: menuNavigation,
    state: state
  };
  if (category !== undefined) {
    tmp$1.category = Caml_option.valFromOption(category);
  }
  return React.createElement(Atom_Column.make, tmp, React.createElement(Molecule_BurgerMenuIcon.make, {
                  state: state,
                  toggle: handleToggle,
                  style: Molecule_BurgerMenuIcon_Ds.header
                }), React.createElement(Organism_MenuNavigation.make, tmp$1));
}

var make = Organism_BurgerMenu;

exports.make = make;
/* CssJs Not a pure module */
